// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <p>Our Urgent Care Eligibility API was deactivated on July 20, 2020. The API and related<br />
      documentation is no longer accessible. For more information, <a href="/support/contact-us">contact us</a><br />
      or visit our <a href="https://groups.google.com/forum/m/#!forum/va-lighthouse">Google Developer Forum</a>.</p>
    </div>
  );
};

export default MarkdownComponent;
